import type { ComponentProps } from "react";
import { LuBold } from "react-icons/lu";

import { Button } from "@/components/ui/button";

import { EDITOR_MODE } from "../constants";
import { useEditorContext } from "../editor-context";

export const EditorActionFormatting = (
  props: ComponentProps<typeof Button>,
) => {
  const { mode, setEditorContext } = useEditorContext();

  return (
    <Button
      {...props}
      onClick={() =>
        setEditorContext({
          mode:
            mode === EDITOR_MODE.SIMPLE ? EDITOR_MODE.RICH : EDITOR_MODE.SIMPLE,
        })
      }
    >
      <LuBold className="text-lg" />
    </Button>
  );
};
